import { createSlice } from "@reduxjs/toolkit";
import { aegisApi } from "./aegisApi";

const initialState = {
  roles: null,
};
console.log("danumenyavpizdu", aegisApi);
const aegisSlice = createSlice({
  name: "aegisSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      aegisApi.endpoints.getAllroles.matchFulfilled,
      (state, action) => {
        state.roles = action.payload.data.map((item) => item.attributes.key);
      }
    );
  },
});

export default aegisSlice.reducer;
